module.exports = "/static/assets/1cb157de017b539c4f4e761d7847956e.gif";